import { render, staticRenderFns } from "./RoboKlausLite.vue?vue&type=template&id=3448d43a&"
import script from "./RoboKlausLite.vue?vue&type=script&lang=js&"
export * from "./RoboKlausLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports